/**
 * Check if the logged-in parent has a given permission.
 * Permission strings are defined on the backend under the parent role.
 * Example: ParentPermissionChecker("parent.view_attendance")
 */
export const ParentPermissionChecker = (permission) => {
  try {
    const user = JSON.parse(localStorage.getItem("parentUser") || "{}");
    if (!user || !user.roles) return false;
    return user.roles.some((role) =>
      role.permissions?.some(
        (p) => p.name.toLowerCase() === permission.toLowerCase()
      )
    );
  } catch {
    return false;
  }
};
